module.exports = __webpack_public_path__ + "img/u.55a76675.jpg";